export enum ServiceStateEnums{
  abierto = 1,
  cerrado = 2,
  anulado = 3,
  impreso = 4
}